import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import { RowWrapper } from './Client/Client.styles';

export const TitleRow = styled(RowWrapper)`
    height: 44px;
    font-size: 12px;
    line-height: 24px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    background-color: unset;
    > p {
        margin: 0;
        opacity: .87
    }
    :hover {
        background-color: unset;
    }
`;

export const InputWrapper = styled.div`
    width: 940px;
    margin: ${({ theme }) => theme.spacing * 30}px auto
        ${({ theme }) => theme.spacing * 10}px;
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        width: 460px;
        @media screen and (max-width: 690px) {
            width: 100%;
        }
    }
`;
